const HOLO_URL =
  "https://customer-assets.emergentagent.com/job_18d0b8e0-400c-48e8-b04b-0dc215769997/artifacts/6zjyiget_6fa730058b3e4e877eaaa5422b176bc1.png";

export default function HolographicBg() {
  return (
    <>
      <div
        className="holo-bg-layer holo-bg-1"
        style={{ backgroundImage: `url(${HOLO_URL})` }}
        data-testid="holo-bg-layer-1"
      />
      <div
        className="holo-bg-layer holo-bg-2"
        style={{ backgroundImage: `url(${HOLO_URL})` }}
        data-testid="holo-bg-layer-2"
      />
      <div className="holo-vignette" />
    </>
  );
}
